import { fetchCmsData } from '../../../../cms/cmsActions';
import { getCmsData } from '../../../../cms/cmsSelector';
import { CmsEntities } from '../../../../cms/cmsConstants';

import { getCurrentUserSegment } from '../../../currentUserSelector';
import { createSelector } from 'reselect';
import { prop } from '../../../../../common/utils/immutableHelper';

export const getCurrentUserReleventSegmentData = getCmsData(CmsEntities.SEGMENTS_MOST_RELEVANT);

export const getCurrentUserRelevantSegmentSuggestedBoardTitles = createSelector(
    getCurrentUserReleventSegmentData,
    (relevantSegment) => prop('suggestedBoardTitles', relevantSegment),
);

export const fetchCurrentUserMostReleventSegment = () => async (dispatch, getState) => {
    const state = getState();
    const segmentData = getCurrentUserReleventSegmentData(state);

    if (segmentData) return segmentData;

    const userSegment = getCurrentUserSegment(state);

    await dispatch(fetchCmsData(CmsEntities.SEGMENTS_MOST_RELEVANT)({ segment: userSegment }));

    return getCurrentUserReleventSegmentData(getState());
};
